/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InlineResponse20012Attempt model module.
 * @module model/InlineResponse20012Attempt
 * @version 1.0.0
 */
class InlineResponse20012Attempt {
    /**
     * Constructs a new <code>InlineResponse20012Attempt</code>.
     * @alias module:model/InlineResponse20012Attempt
     */
    constructor() { 
        
        InlineResponse20012Attempt.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InlineResponse20012Attempt</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InlineResponse20012Attempt} obj Optional instance to populate.
     * @return {module:model/InlineResponse20012Attempt} The populated <code>InlineResponse20012Attempt</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InlineResponse20012Attempt();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('attempt_number')) {
                obj['attempt_number'] = ApiClient.convertToType(data['attempt_number'], 'Number');
            }
            if (data.hasOwnProperty('has_cost')) {
                obj['has_cost'] = ApiClient.convertToType(data['has_cost'], 'Boolean');
            }
            if (data.hasOwnProperty('cost')) {
                obj['cost'] = ApiClient.convertToType(data['cost'], 'Number');
            }
            if (data.hasOwnProperty('is_paid')) {
                obj['is_paid'] = ApiClient.convertToType(data['is_paid'], 'Boolean');
            }
            if (data.hasOwnProperty('is_used')) {
                obj['is_used'] = ApiClient.convertToType(data['is_used'], 'Boolean');
            }
            if (data.hasOwnProperty('is_approved')) {
                obj['is_approved'] = ApiClient.convertToType(data['is_approved'], 'Boolean');
            }
            if (data.hasOwnProperty('approved_at')) {
                obj['approved_at'] = ApiClient.convertToType(data['approved_at'], 'String');
            }
            if (data.hasOwnProperty('attempts_available')) {
                obj['attempts_available'] = ApiClient.convertToType(data['attempts_available'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
InlineResponse20012Attempt.prototype['id'] = undefined;

/**
 * @member {Number} attempt_number
 */
InlineResponse20012Attempt.prototype['attempt_number'] = undefined;

/**
 * @member {Boolean} has_cost
 */
InlineResponse20012Attempt.prototype['has_cost'] = undefined;

/**
 * @member {Number} cost
 */
InlineResponse20012Attempt.prototype['cost'] = undefined;

/**
 * @member {Boolean} is_paid
 */
InlineResponse20012Attempt.prototype['is_paid'] = undefined;

/**
 * @member {Boolean} is_used
 */
InlineResponse20012Attempt.prototype['is_used'] = undefined;

/**
 * @member {Boolean} is_approved
 */
InlineResponse20012Attempt.prototype['is_approved'] = undefined;

/**
 * @member {String} approved_at
 */
InlineResponse20012Attempt.prototype['approved_at'] = undefined;

/**
 * @member {Number} attempts_available
 */
InlineResponse20012Attempt.prototype['attempts_available'] = undefined;






export default InlineResponse20012Attempt;

